export default function StatsBar() {
  return (
    <div
      style={{
        background: '#f5c518',
        color: '#000',
        padding: '30px 12px',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '8px',
          textAlign: 'center',
        }}
      >
        <div>
          <div style={{ fontSize: '26px', fontWeight: 700 }}>500+</div>
          <div style={{ fontSize: '11px', marginTop: '4px', letterSpacing: '1px', fontWeight: 600 }}>
            CARS DELIVERED
          </div>
        </div>
        <div>
          <div style={{ fontSize: '26px', fontWeight: 700 }}>7+</div>
          <div style={{ fontSize: '11px', marginTop: '4px', letterSpacing: '1px', fontWeight: 600 }}>
            YEARS EXPERIENCE
          </div>
        </div>
        <div>
          <div style={{ fontSize: '26px', fontWeight: 700 }}>4.5★</div>
          <div style={{ fontSize: '11px', marginTop: '4px', letterSpacing: '1px', fontWeight: 600 }}>
            GOOGLE RATING
          </div>
        </div>
      </div>
    </div>
  );
}